import {type MutationTree} from 'vuex';
import {NoOperation} from '../../../../library/utils';
import dateHelper from '../../../../utils/portuna/dateHelper';
import store from '../../../index';

const mutations: MutationTree<ModuleChatState> = {

    lastUpdate(state, lastUpdate: string)
    {
        state.lastUpdate = lastUpdate;
    },

    participantChats(state, participantChats: Chat[])
    {
        state.participantChats = participantChats;
    },

    strangerChats(state, strangerChats: Chat[])
    {
        state.strangerChats = strangerChats;
    },

    isAdmin(state, isAdmin: boolean)
    {
        state.isAdmin = isAdmin;
    },

    toggleVisibility(state, show: boolean)
    {
        state.showChat = show;
    },

    setUnreadMessagesCount(state, count: number)
    {
        state.totalUnreadMessages = count;
    },

    setTab(state, tab: ChatTabType)
    {
        state.activeTab = tab;
    },

    setDetailsOpen(state, status: boolean)
    {
        state.detailsOpen = status;
    },

    setChat(state, chat: Chat)
    {
        state.activeChat = chat;
    },

    updateChatLastMessage(state, {
        message,
        currentUser,
    }: { message: ChatNewMessage, currentUser: number })
    {
        for (let chat of [...state.participantChats, ...state.strangerChats])
        {
            if (chat.id === message.chat_id)
            {
                chat.last_message_id      = message.id;
                chat.last_message_created = message.created;
                chat.last_message_text    = 'undefined' === typeof message.teaser ? message.text : message.teaser;
                chat.last_message_creator = message.creator;
                chat.last_message_type    = message.type;
                chat.last_message_read    = 0;

                if (message.creator === currentUser)
                {
                    chat.new_messages = 0;
                    chat.last_read    = dateHelper('Y-m-d H:i:s') as string;
                }
                else if (!state.activeChat || state.activeChat.id !== chat.id)
                {
                    chat.new_messages++;
                }

                store.dispatch('updateFaviconBadge').finally(NoOperation);
                break;
            }
        }
    },

    updateChatLastRead(state, {
        chat: chatId,
        timestamp,
    }: { chat: number, timestamp: string })
    {
        for (let chat of [...state.participantChats, ...state.strangerChats])
        {
            if (chat.id === chatId)
            {
                chat.last_read    = timestamp;
                chat.new_messages = 0;
                store.dispatch('updateFaviconBadge').finally(NoOperation);
                break;
            }
        }
    },

    updateChatLastMessageRead(state, {
        chat: chatId,
    }: { chat: number })
    {
        for (let chat of [...state.participantChats, ...state.strangerChats])
        {
            if (chat.id === chatId)
            {
                chat.last_message_read = 1;
                break;
            }
        }
    },

    updateChat(state, {
        savedChat,
        currentUser,
    }: { savedChat: Chat, currentUser: number })
    {

        let chatExist = false;
        for (let chat of [...state.participantChats, ...state.strangerChats])
        {
            if (chat.id === savedChat.id)
            {
                Object.assign(chat, savedChat);
                chatExist = true;
                break;
            }
        }

        if (!chatExist)
        {
            let addToParticipant = false;
            for (let participant of savedChat.participants)
            {
                if (participant.user_id === currentUser)
                {
                    addToParticipant = true;
                    break;
                }
            }

            if (addToParticipant)
            {
                state.participantChats.push(savedChat);
            }
            else
            {
                state.strangerChats.push(savedChat);
            }
        }
    },

    deleteChat(state, deletedChat: number)
    {
        let chatFound = false;
        for (let index in state.participantChats)
        {
            if (!state.participantChats.hasOwnProperty(index))
            {
                continue;
            }
            if (state.participantChats[index].id === deletedChat)
            {
                chatFound = true;
                state.participantChats.splice(parseInt(index), 1);
            }
        }

        if (!chatFound)
        {
            for (let index in state.strangerChats)
            {
                if (!state.strangerChats.hasOwnProperty(index))
                {
                    continue;
                }
                if (state.strangerChats[index].id === deletedChat)
                {
                    chatFound = true;
                    state.strangerChats.splice(parseInt(index), 1);
                }
            }
        }
    },

    participantLeft(state, {
        chat: chatId,
        user,
    }: { chat: number, user: number })
    {
        for (let index in state.participantChats)
        {
            if (!state.participantChats.hasOwnProperty(index))
            {
                continue;
            }

            if (state.participantChats[index].id === chatId)
            {
                for (let participantIndex in state.participantChats[index].participants)
                {
                    if (!state.participantChats[index].participants.hasOwnProperty(participantIndex))
                    {
                        continue;
                    }

                    if (state.participantChats[index].participants[participantIndex].user_id === user)
                    {
                        state.participantChats[index].participants.splice(parseInt(participantIndex), 1);
                    }
                }

                const _chat = state.strangerChats.splice(parseInt(index), 1);
                state.strangerChats.push(..._chat);
            }
        }
    },

    toggleChatStatus(state, chatId: number)
    {
        for (const chat of ([] as Chat[]).concat(state.participantChats, state.strangerChats))
        {
            if (chat.id === chatId)
            {
                chat.active = chat.active ? 0 : 1;
                break;
            }
        }
    },

    setReply(state, message: Nullable<ChatMessage>)
    {
        state.reply = message;
    },
};

export default mutations;